//const Backofficebff: string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;
//const Backofficebff         : string = "/api";

export const BillingCommand: any = {
    DeleteBillingInformation: Backofficebff + '/v1/billinglogs/deletebillinginformation',
    PostGetBillingInformation: Backofficebff + '/v1/billinglogs/getbillinginformation',
    UpdateBillingInformation: Backofficebff + '/v1/billinglogs/updatebillinginformation',
    GetDocumentNo: Backofficebff + '/v1/billinglogs/getdocumentno',
    GetExpenseBill: Backofficebff + '/v1/billinglogs/getexpensebill',
};
